import { History, Location } from "history";
import { GetEmployeeProfilesQueryProps } from "Shared/types/EmployeeProfiles";
import { propsToQuery } from "Api";
import { useHistory } from "Hooks/useRouter";

export const goToPageCreator = (history: History, targetBaseRoute: string) => {
  return (queryProps: GetEmployeeProfilesQueryProps) => {
    history.push(`${targetBaseRoute}${propsToQuery(queryProps)}`);
  };
};

export const useGoToGrossEarningsPage = () => {
  const history = useHistory();
  return (page: number) => {
    history.push(`/grossearnings?page=${page}`);
  };
};

export const goToUserDetails = (history: History) => {
  return (id: string) => {
    history.push({
      pathname: `/users/${id}/details`,
    });
  };
};

export const redirectTo = (
  pathFrom: string,
  pathTo: string,
  history: History,
  location: Location
) => {
  if (location.pathname === pathFrom) {
    history.push(pathTo);
  }
};
